module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Close-1827c39bc7515bb5d5267bca822740cc.svg";